import { useState, useEffect } from 'react';
import mixpanel from 'Utils/mixpanel';
import EnvironmentManager from 'Utils/environmentManager';

export const useFastDepositABTest = () => {
  const FAST_DEPOSIT_AB_TEST_FLAG = EnvironmentManager.getMessageText({ key: 'fast_deposit_mixpanel_key_web' });
  const [flagValue, setFlagValue] = useState(null);

  useEffect(() => {
    const checkFastDepositABTest = async () => {
      try {
        if (mixpanel?.flags && typeof mixpanel.flags.get_variant_value === 'function') {
          const value = await mixpanel.flags.get_variant_value(FAST_DEPOSIT_AB_TEST_FLAG);
          setFlagValue(value);
        }
      } catch (error) {
        console.error('Fast Deposit A/B test flag error:', error);
      }
    };
    checkFastDepositABTest();
  }, []);

  const CMS_FAST_DEPOSIT_SWITCH = EnvironmentManager.getMessageText({ key: 'deposit_page_fast_deposit_switch_v2' }) === 'true';
  const fastDepositFallback = EnvironmentManager.getMessageText({ key: 'deposit_page_fast_deposit_switch_v2_fallback' }) || '01';

  let isFastDepositEnabled = false;

  if (CMS_FAST_DEPOSIT_SWITCH) {
    const variant = flagValue != null ? String(flagValue) : fastDepositFallback;
    if (variant === '2' || variant === '02') {
      isFastDepositEnabled = true;
    } else if (variant === '1' || variant === '01') {
      isFastDepositEnabled = false;
    } else {
      isFastDepositEnabled = fastDepositFallback === '02';
    }
  }

  return {
    flagValue,
    isFastDepositEnabled,
    isLoading: flagValue === null
  };
};

export default useFastDepositABTest;
